import { render, staticRenderFns } from "./we-series.vue?vue&type=template&id=448f3473&scoped=true&"
import script from "./we-series.vue?vue&type=script&lang=js&"
export * from "./we-series.vue?vue&type=script&lang=js&"
import style0 from "./we-series.vue?vue&type=style&index=0&id=448f3473&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f3473",
  null
  
)

export default component.exports